// extracted by mini-css-extract-plugin
export default {"btnColor":"FormColors_btnColor__LhA0s","listColors":"FormColors_listColors__PIhpH","colorItem":"FormColors_colorItem__tAYxC","checked":"FormColors_checked__a7yGH"};